module.exports = __webpack_public_path__ + "img/avatar4.68ed2024.png";